import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import { preevaluate } from "@next-core/cook";
import { isExpressionString } from "@next-tsx/parser";
export function deepReplaceVariables(value, patterns) {
  if (!(patterns !== null && patterns !== void 0 && patterns.size)) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(function (item) {
      return deepReplaceVariables(item, patterns);
    });
  }
  if (_typeof(value) === "object" && value !== null) {
    return Object.fromEntries(Object.entries(value).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];
      return [k, deepReplaceVariables(v, patterns)];
    }));
  }
  if (typeof value === "string" && isExpressionString(value)) {
    return replaceVariables(value, patterns);
  }
  return value;
}
export function replaceVariables(expr, patterns) {
  if (!(patterns !== null && patterns !== void 0 && patterns.size)) {
    return expr;
  }
  var keywords = _toConsumableArray(patterns.keys());
  if (keywords.some(function (k) {
    return expr.includes(k);
  })) {
    var replacements = [];
    var result;
    try {
      result = preevaluate(expr, {
        withParent: true,
        hooks: {
          beforeVisitGlobal: function beforeVisitGlobal(node, path) {
            if (patterns.has(node.name)) {
              var _ref3;
              var p = (_ref3 = path[path.length - 1]) === null || _ref3 === void 0 ? void 0 : _ref3.node;
              var shorthand;
              if (p && p.type === "Property" && !p.computed && p.shorthand) {
                shorthand = true;
              }
              replacements.push({
                id: node,
                shorthand: shorthand
              });
            }
          }
        }
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Parse expression failed:", error);
    }
    if (replacements.length > 0 && result) {
      var _result = result,
        prefix = _result.prefix,
        source = _result.source,
        suffix = _result.suffix;
      var chunks = [];
      var prevStart = 0;
      for (var i = 0; i < replacements.length; i++) {
        var _replacements$i = replacements[i],
          id = _replacements$i.id,
          shorthand = _replacements$i.shorthand;
        var name = id.name,
          start = id.start,
          end = id.end;
        chunks.push(source.substring(prevStart, start), "".concat(shorthand ? "".concat(name, ": ") : "").concat(patterns.get(name)));
        prevStart = end;
      }
      chunks.push(source.substring(prevStart));
      return "".concat(prefix).concat(chunks.join("")).concat(suffix);
    }
  }
  return expr;
}
//# sourceMappingURL=deepReplaceVariables.js.map